const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/about"],
    exact: true,
    component: "AboutUs",
  },
  {
    path: ["/services"],
    exact: true,
    component: "Services",
  },
  {
    path: ["/courses"],
    exact: true,
    component: "Courses",
  },
  {
    path: ["/register", "/registration"],
    exact: true,
    component: "Registration",
  },
];

export default routes;
